import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBrandsProps, IconRender } from '../types.ts';

const Instagram = React.forwardRef<SVGSVGElement | null, IconBrandsProps>(function Instagram({ colored, dataTestId, ...props }, ref) {
  const gradientId = React.useId();
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* Defs for the linear gradients */}
        <defs>
          <linearGradient id={gradientId} x1='6.5' y1='0' x2='-2' y2='22' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#6A49C7' />
            <stop offset='0.239583' stopColor='#D03596' />
            <stop offset='0.463542' stopColor='#F04252' />
            <stop offset='0.682292' stopColor='#EF892B' />
            <stop offset='0.848958' stopColor='#EFB149' />
            <stop offset='1' stopColor='#E9CD7E' />
          </linearGradient>
        </defs>
        {/* default */}
        <path
          d='M16.233 2H7.77256C4.58173 2 2 4.58731 2 7.77256V16.2274C2 19.4183 4.58731 22 7.77256 22H16.2274C19.4183 22 22 19.4127 22 16.2274V7.77256C22.0056 4.58173 19.4183 2 16.233 2ZM20.1615 16.3783C20.1615 18.4962 18.4459 20.2118 16.328 20.2118H7.67198C5.55406 20.2118 3.8385 18.4962 3.8385 16.3783V7.72227C3.8385 5.60436 5.55406 3.8888 7.67198 3.8888H16.328C18.4459 3.8888 20.1615 5.60436 20.1615 7.72227V16.3783Z'
          fill={colored ? 'transparent' : color}
        />
        <path
          d='M12.0028 6.86167C9.13607 6.86167 6.8114 9.18634 6.8114 12.0531C6.8114 14.9198 9.13607 17.2445 12.0028 17.2445C14.8695 17.2445 17.1942 14.9198 17.1942 12.0531C17.1942 9.18634 14.8695 6.86167 12.0028 6.86167ZM12.0028 15.4171C10.1419 15.4171 8.63873 13.9083 8.63873 12.0531C8.63873 10.1922 10.1475 8.689 12.0028 8.689C13.8637 8.689 15.3669 10.1978 15.3669 12.0531C15.3669 13.9083 13.8581 15.4171 12.0028 15.4171Z'
          fill={colored ? 'transparent' : color}
        />
        <path
          d='M17.3674 7.86756C18.034 7.86756 18.5745 7.32715 18.5745 6.66052C18.5745 5.99389 18.034 5.45348 17.3674 5.45348C16.7008 5.45348 16.1604 5.99389 16.1604 6.66052C16.1604 7.32715 16.7008 7.86756 17.3674 7.86756Z'
          fill={colored ? 'transparent' : color}
        />
        {/* colored */}
        <path
          d='M16.233 2H7.77256C4.58173 2 2 4.58731 2 7.77256V16.2274C2 19.4183 4.58731 22 7.77256 22H16.2274C19.4183 22 22 19.4127 22 16.2274V7.77256C22.0056 4.58173 19.4183 2 16.233 2ZM20.1615 16.3783C20.1615 18.4962 18.4459 20.2118 16.328 20.2118H7.67198C5.55406 20.2118 3.8385 18.4962 3.8385 16.3783V7.72227C3.8385 5.60436 5.55406 3.8888 7.67198 3.8888H16.328C18.4459 3.8888 20.1615 5.60436 20.1615 7.72227V16.3783Z'
          fill={colored ? `url(#${gradientId})` : 'transparent'}
        />
        <path
          d='M12.0028 6.86167C9.13607 6.86167 6.8114 9.18634 6.8114 12.0531C6.8114 14.9198 9.13607 17.2445 12.0028 17.2445C14.8695 17.2445 17.1942 14.9198 17.1942 12.0531C17.1942 9.18634 14.8695 6.86167 12.0028 6.86167ZM12.0028 15.4171C10.1419 15.4171 8.63873 13.9083 8.63873 12.0531C8.63873 10.1922 10.1475 8.689 12.0028 8.689C13.8637 8.689 15.3669 10.1978 15.3669 12.0531C15.3669 13.9083 13.8581 15.4171 12.0028 15.4171Z'
          fill={colored ? `url(#${gradientId})` : 'transparent'}
        />
        <path
          d='M17.3674 7.86756C18.034 7.86756 18.5745 7.32715 18.5745 6.66052C18.5745 5.99389 18.034 5.45348 17.3674 5.45348C16.7008 5.45348 16.1604 5.99389 16.1604 6.66052C16.1604 7.32715 16.7008 7.86756 17.3674 7.86756Z'
          fill={colored ? `url(#${gradientId})` : 'transparent'}
        />
      </>
    ),
    [colored, gradientId],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'instagram-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Instagram;
